module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.element.na || _vm.parent.viewNaFields) ? _c('div', {
    staticClass: "layout-element"
  }, [(!_vm.parent.hideIndicators) ? _c('div', {
    staticClass: "indicator-column"
  }, [_c('div', {
    staticClass: "layout-indicator shadow-pulse",
    class: {
      complete: _vm.element.value
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.parent.hideIcons) ? _c('div', {
    staticClass: "icon-column"
  }, [_vm._t("left", [(_vm.element.icon) ? _c('v-icon', {
    staticClass: "layout-icon",
    attrs: {
      "color": "grey"
    }
  }, [_vm._v(_vm._s(_vm.element.icon))]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "controls-column"
  }, [_c('div', {
    staticClass: "control-c2"
  }, [(_vm.element.na) ? _c('div', {
    staticClass: "na-overlay"
  }, [_vm._v("NOT APPLICABLE")]) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v("No Content")])], 2), _vm._v(" "), _c('div', {
    staticClass: "control-c3"
  }, [_vm._t("right")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c67524"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ElementLayout.vue
// module id = 2534
// module chunks = 1